var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveGetItLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4238_6848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17285 9.37608C9.17285 10.177 9.82222 10.827 10.623 10.8273H19.1445C18.7227 15.5013 14.796 19.165 10.0117 19.1651C7.6361 19.1651 5.47255 18.2624 3.84277 16.7804L3.52344 16.4767C1.86159 14.8157 0.834961 12.5225 0.834961 9.98839C0.835 5.20405 4.49866 1.27723 9.17285 0.855576V9.37608Z",
    stroke: "#5f5f5f",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0811 0.918701V6.79565H17.2148C16.9665 5.92179 15.8527 5.54028 15.1201 6.1687L15.042 6.24194L14.5791 6.70386L13.2959 5.42065L13.7578 4.95874C14.4866 4.22998 14.1102 3.04116 13.2041 2.78394V0.918701H19.0811Z",
    stroke: "#5f5f5f",
    strokeWidth: 1.67
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4238_6848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveGetItLogo);
export default __webpack_public_path__ + "static/media/InactiveGetItLogo.7d2526968c4b070eaf6f83ce04750201.svg";
export { ForwardRef as ReactComponent };